import React, {useState} from "react";
import Button from "../../components/Button.jsx";
import {useTranslation} from "react-i18next";
import DeleteProjectYesNo from "./DeleteProjectYesNo.jsx";

export default function DeleteProjectContent({project}) {
    let {t} = useTranslation();

    let [deletePressed, setDeletePressed] = useState(false);

    return (
        <>
            <DeleteProjectYesNo
                visible={deletePressed}
                setVisible={setDeletePressed}
                project={project}
            />

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                    {t('project.to-delete-project-press-button')}
                </div>

                <div className="shrink-0">
                    <Button variant="outline-red" onClick={() => setDeletePressed(true)}>
                        {t('project.delete')}
                    </Button>
                </div>

            </div>
        </>
    );

}
